import { DISABLED_TYPES } from "../constants/GlobalConstants";


const useDisableAsPerDepartmentType = (department) =>{
  return DISABLED_TYPES.includes(department?.departmentType);
}

export default useDisableAsPerDepartmentType